import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class AccordionBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        'container': 'data-accordion',
        'row': 'data-accordion-row',
        'toggle': 'date-accordion-toggle'
    };

    getContainerSelector = () => {
        return '[' + this.attrNames.container + ']';
    };

    getRowSelector = () => {
        return '[' + this.attrNames.row + ']';
    };

    getToggleSelector = () => {
        return '[' + this.attrNames.toggle + ']';
    };

    onToggle = (accordionRows, accordionRow) => {
        let wasActive = accordionRow.classList.contains('active');
        accordionRows.forEach(row => {
            row.classList.remove('active');
        });

        if(!wasActive) accordionRow.classList.add('active');
    };

    initContainer = (container) =>  {
        const accordionRows = Array.from(container.querySelectorAll(this.getRowSelector()));

        accordionRows.forEach(accordionRow => {
            accordionRow.querySelector(this.getToggleSelector()).addEventListener('click', () => { this.onToggle(accordionRows, accordionRow) });
        });
    }
}